import { NativeBridgeResponse } from 'scbk-services/types/bridge/global';
import { NativeBridgeCallOptions, NativeBridgeService } from '../manager/nativeBridgeService';

/**
 * 제일은행 네이티브 브릿지 hook
 * @returns
 */
const useNativeBridge = () => {
    /**
     * 네이티브 브릿지 호출 함수
     * @param action 브릿지 액션
     * @param request 요청 데이터
     * @param options 브릿지 호출 옵션
     * @returns
     */
    const call = async <I, O>(
        action: string,
        request?: I,
        options?: NativeBridgeCallOptions<O>,
    ) => {
        const nativeBridgeService: NativeBridgeService = NativeBridgeService.getInstance();
        // try {
        //     const res = (await nativeBridgeService.call(
        //         action,
        //         request,
        //         options,
        //     )) as NativeBridgeResponse<O>;
        //     return res;
        // } catch (e) {
        //     //중복호출인경우 무시
        //     if (String(e).includes('DUPLICATE_NATIVE_CALL')) {
        //         return;
        //     }
        // }
        const res = (await nativeBridgeService.call(
            action,
            request,
            options,
        )) as NativeBridgeResponse<O>;
        return res;
    };

    return call;
};

const useNativeBridgeWithCallback = () => {
    /**
     * 네이티브 브릿지 호출 함수
     * @param action 브릿지 액션
     * @param request 요청 데이터
     * @param options 브릿지 호출 옵션
     * @returns
     */
    const call = <I, O>(action: string, request?: I, options?: NativeBridgeCallOptions<O>) => {
        const nativeBridgeService: NativeBridgeService = NativeBridgeService.getInstance();
        nativeBridgeService.callWithCallback(action, request, options);
    };

    return call;
};

export { useNativeBridge, useNativeBridgeWithCallback };
